import { render, staticRenderFns } from "./theme-cmp.vue?vue&type=template&id=1cfb299f&"
import script from "./theme-cmp.vue?vue&type=script&lang=js&"
export * from "./theme-cmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports